import { Form, Input, Button, Space, Card } from "antd";
import moment from "moment";
import { useMemo } from "react";
import { useUpdateWorkExperience } from "../../../../hooks/api/Tutors/UpdateProfile/useUpdateWorkExperience";

type Props = {
  initialValues: {
    id: string;
    title: string;
    company: string;
    startDate: string;
    endDate: string;
  };
  onCancel: () => void;
};

const UpdateWorkExperienceForm = ({ initialValues, onCancel }: any) => {
  const [form] = Form.useForm();
  const { mutate, isLoading } = useUpdateWorkExperience();

  const formInitialValues = useMemo(() => {
    return {
      ...initialValues,
      startDate: initialValues.startDate
        ? moment(initialValues.startDate).format("YYYY-MM-DD")
        : "",
      endDate: initialValues.endDate
        ? moment(initialValues.endDate).format("YYYY-MM-DD")
        : "",
    };
  }, [initialValues]);

  const onFinish = (values: any) => {
    const formattedValues: any = {
      id: initialValues.id || initialValues._id,
      title: values.title,
      company: values.company,
      startDate: values.startDate
        ? moment.utc(values.startDate, "YYYY-MM-DD").toISOString()
        : null,
      endDate: values.endDate
        ? moment.utc(values.endDate, "YYYY-MM-DD").toISOString()
        : null,
    };

    mutate(formattedValues, {
      onSuccess: () => {
        onCancel();
      },
    });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      initialValues={formInitialValues}
    >
      <Space
        direction="vertical"
        style={{ display: "flex", width: "100%", padding: 0 }}
      >
        <Card size="small" bordered={false}>
          <Form.Item name="title" label="Job Title">
            <Input placeholder="Enter Job Title" size="large" />
          </Form.Item>

          <Form.Item name="company" label="Company">
            <Input placeholder="Enter Company Name" size="large" />
          </Form.Item>

          <div className="flex flex-row gap-2">
            <div className="w-6/12">
              <Form.Item name="startDate" label="Start Date">
                <input
                  type="date"
                  className="w-full border-[1px] rounded-md border-gray300 p-2 outline-none h-[40px]"
                />
              </Form.Item>
            </div>
            <div className="w-6/12">
              <Form.Item name="endDate" label="End Date">
                <input
                  type="date"
                  className="w-full border-[1px] rounded-md border-gray300 p-2 outline-none h-[40px]"
                />
              </Form.Item>
            </div>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={isLoading}>
              Update
            </Button>
          </div>
        </Card>
      </Space>
    </Form>
  );
};

export default UpdateWorkExperienceForm;
